module.exports = __webpack_public_path__ + "images/questions/qa_best_answer_icon_7b04f552ee68a53679b64b37a5758489.png";